import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { UIService } from '@core/services/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { map, of, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

export function permissionGuard(requiredPermission: string) {
  return () => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const uiService = inject(UIService);
    const translateService = inject(TranslateService);

    return authService.authenticate().pipe(
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return of(false);
        }
        return authService.ensureUserAccessLoaded$().pipe(
          map(() => authService.hasPermission(requiredPermission)),
        );
      }),
      switchMap((allowed) => {
        if (allowed) {
          return of(true);
        }
        return translateService.get('errors.noPermission').pipe(
          map((summary) => {
            uiService.showToast({
              severity: 'error',
              summary,
              life: 3000,
              closable: false,
            });
            router.navigate([APP_ROUTES.HOME]);
            return false;
          }),
        );
      }),
    );
  };
}
